exports = module.exports = require("../../../node_modules/_css-loader@0.23.1@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".engine-ghost{box-sizing:border-box;position:fixed;z-index:99999;width:100px;height:24px;left:-15px;top:-12px;display:flex;align-items:center;pointer-events:none;background-color:rgba(0,0,0,.4);opacity:.5}.engine-ghost .engine-ghost-icon{display:block;height:24px;width:24px;margin-left:5px}.engine-ghost .engine-ghost-icon path{fill:var(--color-icon-normal,rgba(31,56,88,.4))}.engine-ghost .engine-ghost-title{flex:1;font-family:PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica,Arial,sans-serif;text-align:center;font-size:12px;text-overflow:ellipsis;color:#fff;white-space:nowrap;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.23.1@css-loader!./~/_less-loader@2.2.3@less-loader!./lib/engine/ui/ghost.less
// module id = 230
// module chunks = 0